import { Suspense, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { Outlet, useLocation } from "react-router";
import { useAppDispatch, useAppSelector } from "@/redux-store/hooks";
import { fetchCartById } from "@/api/fetchCartById";
import { clearCart } from "@/redux-store/cart/cartSlice";

import Header from "@/components/Header";
import Footer from "@/components/Footer/Footer";
import TestDrive from "@/components/TestDrive";
import { getTestDriveSection } from "@/utils/getTestDriveSection";

const MainLayout = () => {
  const location = useLocation();
  const hasTestDrive = getTestDriveSection(location);
  const dispatch = useAppDispatch();
  const sessionId = useAppSelector((state) => state.cart.sessionId);
  const hasHandled404 = useRef(false);

  useEffect(() => {
    const checkCartItems = async () => {
      if (sessionId && !hasHandled404.current) {
        try {
          const cartData = await fetchCartById(sessionId);
          if (!cartData) {
            hasHandled404.current = true;
            dispatch(clearCart());
          }
        } catch (error: any) {
          if (error.response?.status === 404) {
            hasHandled404.current = true;
            dispatch(clearCart());
          }
        }
      }
    };

    checkCartItems();
  }, [sessionId, dispatch]);

  return (
    <>
      <Header />

      <Box component="main">
        <Suspense fallback={<div>Loading...</div>}>
          <Outlet />
        </Suspense>
      </Box>

      {hasTestDrive && <TestDrive />}
      <Footer />
    </>
  );
};

export default MainLayout;
